angular.module('core').filter('calendarUnit', [
  function() {
    /**
     * Returns 'by' param (day, week, month)
     * @param {Number} interval
     * @return {String}
     */
    return function(interval) {
      // 0-7 days: by Day
      // 8-49 days: by Week
      // 50+ days: by Month

      if (interval < 0) {
        // Error - can't have a 'from' date newer than the 'to' date
        console.error('Invalid date range');
      }
      else if (interval >= 0 && interval <= 7){
        return 'day';
      }
      else if (interval >= 8 && interval <= 49) {
        return 'week';
      }
      else {
        return 'month';
      }
    };
  }
]);
